import { useFormik } from "formik";
import ContentPillarForm from "@serie3/mymediaplanner/Modules/Social/Forms/ContentPillarForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faLayerGroup } from "@fortawesome/free-solid-svg-icons";

const PILLAR_COLORS = ["#038edc", "#51d28c", "#f1734f", "#564ab1", "#f7cc53", "#5fd0f3"];

const CreateContentPillars = ({ contentPillars = [] }) => {
  const pillarForm = ContentPillarForm.createContentPillarForm();
  const formik = useFormik(pillarForm);

  const applyPillar = async (e, pillar) => {
    e.preventDefault();
    await formik.setFieldValue("pillar", pillar.title);
    await formik.setFieldValue("description", pillar.explanation);
    formik.handleSubmit(e);
  };

  if (contentPillars.length === 0) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 200, gap: 16 }}>
        <div style={{ width: 40, height: 40, borderRadius: "50%", border: "3px dotted #038edc", animation: "dotted-spin 0.9s linear infinite" }} />
        <p style={{ color: "#9299a8", fontSize: 14, margin: 0 }}>Generating content pillars…</p>
      </div>
    );
  }

  return (
    <div>
      <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 20 }}>
        Click <strong>Use</strong> on any pillar to add it to your plan. You can add multiple.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 14 }}>
        {contentPillars.map((pillar, index) => {
          const color = PILLAR_COLORS[index % PILLAR_COLORS.length];
          return (
            <div
              key={index}
              style={{
                flex: "1 1 240px", padding: "20px", borderRadius: 14,
                border: `2px solid ${color}30`,
                background: `${color}08`,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                  background: `${color}18`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <FontAwesomeIcon icon={faLayerGroup} style={{ color, fontSize: 15 }} />
                </div>
                <span style={{ fontWeight: 700, fontSize: 15, color: "#111827" }}>{pillar.title}</span>
              </div>
              <p style={{ fontSize: 13, color: "#4b5563", lineHeight: 1.6, marginBottom: 16 }}>
                {pillar.explanation}
              </p>
              <button
                type="button"
                onClick={(e) => applyPillar(e, pillar)}
                style={{
                  display: "inline-flex", alignItems: "center", gap: 6,
                  padding: "7px 16px", borderRadius: 50, border: "none",
                  background: color, color: "#fff",
                  fontSize: 13, fontWeight: 600, cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={faCheck} style={{ fontSize: 11 }} />
                Use
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CreateContentPillars;
